export default "__VITE_ASSET__BvCFrdes__"